
$(function() {
  const $header = $('header');
  const $mobileMenu = $('.ne-navigation-container.mobile');
  
  const calculateMenuHeight = function() {
    const headerHeight = $header.height();
    const windowHeight = $(window).height();
    const style = ":root{--navigation-height:" + headerHeight + "px; --window-height:" + windowHeight + "px;}";
    $("#css-web").empty().html(style);
  }
  
  $(".hamburger")
    .on("click", function(evt): void {
      evt.preventDefault();
      $mobileMenu.toggleClass("visible");
      calculateMenuHeight();
    });
  
  $(window).on("resize", calculateMenuHeight);

  calculateMenuHeight();
});
